import React, { Component } from 'react';
import Modal from '../../commons/modal/modal';
import DatePicker from '../../commons/datePicker/datePicker';
import moment from 'moment';
import styles from './downloadReportModal.scss';

const MAX_RANGE_MONTHS = 6;

class DownloadReportModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null
    };
  }

  handleStartDateChange = date => {
    this.setState({ startDate: date }, () => {
      const { startDate, endDate } = this.state;
      if (startDate && endDate) {
        const maxEndDate = moment(startDate)
          .add(MAX_RANGE_MONTHS, 'months')
          .subtract(1, 'days');
        if (moment(endDate).isAfter(maxEndDate)) {
          this.setState({ endDate: null });
        }
      }
      if (
        this.endDatePicker &&
        typeof this.endDatePicker.setFocus === 'function'
      ) {
        this.endDatePicker.setFocus();
      }
    });
  };

  handleEndDateChange = date => {
    this.setState({ endDate: date });
  };

  handleEndDateRef = c => {
    this.endDatePicker = c;
  };

  handleDownload = () => {
    const { startDate, endDate } = this.state;

    if (!startDate || !endDate) {
      return;
    }

    const startDateTime = moment(startDate)
      .startOf('day')
      .valueOf();
    const endDateTime = moment(endDate)
      .endOf('day')
      .valueOf();

    this.props.onDownload(startDateTime, endDateTime);
  };

  render() {
    const { showModal, closeModal } = this.props;
    const { startDate, endDate } = this.state;
    const isDisabled = !startDate || !endDate;

    return (
      <Modal
        showModal={showModal}
        title="BlinkIT AD CNs Status File"
        closeModal={closeModal}
        minWidth="400px"
        classNameProp="download-report-modal"
        customBodyStyles={{
          fontWeight: 'normal'
        }}
        customHeaderClassName={styles.customHeader}
        customTitleClassName={styles.customTitle}
      >
        <div className={styles.downloadModalContent}>
          <div className={styles.dateInputsWrapper}>
            <div className={styles.dateInputGroup}>
              <label className={styles.dateLabel}>Start Date</label>
              <DatePicker
                name="startDate"
                startDate={startDate}
                onChange={this.handleStartDateChange}
                placeholderText="mm/dd/yyyy"
                dateFormat="MM/dd/yyyy"
                minDate={new Date('2020-01-01')}
                maxDate={new Date()}
                className={styles.datePickerInput}
                selectsStart={true}
                rangeStartDate={startDate ? new Date(startDate) : null}
                calendarClassName="orange-theme-datepicker"
              />
            </div>

            <div className={styles.dateInputGroup}>
              <label className={styles.dateLabel}>End Date</label>
              <DatePicker
                ref={this.handleEndDateRef}
                name="endDate"
                startDate={endDate}
                onChange={this.handleEndDateChange}
                placeholderText="mm/dd/yyyy"
                dateFormat="MM/dd/yyyy"
                minDate={startDate || new Date('2020-01-01')}
                maxDate={
                  startDate
                    ? moment
                        .min(
                          moment(),
                          moment(startDate)
                            .add(MAX_RANGE_MONTHS, 'months')
                            .subtract(1, 'days')
                        )
                        .toDate()
                    : new Date()
                }
                openToDate={startDate ? new Date(startDate) : undefined}
                highlightDates={
                  startDate
                    ? [
                        {
                          'react-datepicker__day--highlighted-orange': [
                            new Date(startDate)
                          ]
                        }
                      ]
                    : []
                }
                className={styles.datePickerInput}
                selectsEnd={true}
                rangeStartDate={startDate ? new Date(startDate) : null}
                rangeEndDate={endDate ? new Date(endDate) : null}
                calendarClassName="orange-theme-datepicker"
              />
            </div>
          </div>

          <div className={styles.helperText}>
            Please select the start and end dates for your download.
          </div>

          <div className={styles.buttonWrapper}>
            <button
              className={`action-button ${isDisabled ? 'disabled' : ''}`}
              onClick={this.handleDownload}
              disabled={isDisabled}
            >
              Download
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default DownloadReportModal;
